module.exports = __webpack_public_path__ + "img/skl.02bb71f7.svg";